export const MakeIcon = ({
  className,
  size
}: {
  className?: string;
  size?: number;
}) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.9322 19.8292H18.0307C17.8091 19.8292 17.6302 19.6492 17.6302 19.4288V8.71594C17.6302 8.49439 17.8103 8.31548 18.0307 8.31548H20.9322C21.1538 8.31548 21.3327 8.49439 21.3327 8.71594V19.4288C21.3327 19.6492 21.1538 19.8292 20.9322 19.8292ZM8.01686 19.6906L12.8271 10.1187C12.9266 9.92087 12.8472 9.68036 12.6494 9.58084L10.0571 8.27757C9.85921 8.17805 9.61869 8.25743 9.51917 8.45529L4.70894 18.0272C4.60942 18.225 4.6888 18.4656 4.88666 18.5651L7.47897 19.8683C7.67683 19.9667 7.91734 19.8873 8.01686 19.6906ZM15.1362 19.6527L17.1942 9.21947C17.2369 9.00266 17.0971 8.79295 16.8803 8.74912L14.0356 8.17449C13.8188 8.13066 13.6067 8.27165 13.5628 8.48846V8.48965L11.5049 18.9229C11.4622 19.1397 11.602 19.3494 11.8188 19.3932L14.6635 19.9679C14.8803 20.0117 15.0924 19.8707 15.1362 19.6539C15.1362 19.6539 15.1362 19.6539 15.1362 19.6527Z"
        fill="#374151"
      />
      <mask
        id="mask0_18732_33912"
        maskUnits="userSpaceOnUse"
        x="4"
        y="8"
        width="18"
        height="12"
      >
        <path
          d="M20.9322 19.8292H18.0307C17.8091 19.8292 17.6302 19.6492 17.6302 19.4288V8.71594C17.6302 8.49439 17.8103 8.31548 18.0307 8.31548H20.9322C21.1538 8.31548 21.3327 8.49439 21.3327 8.71594V19.4288C21.3327 19.6492 21.1538 19.8292 20.9322 19.8292ZM8.01686 19.6906L12.8271 10.1187C12.9266 9.92087 12.8472 9.68036 12.6494 9.58084L10.0571 8.27757C9.85921 8.17805 9.61869 8.25743 9.51917 8.45529L4.70894 18.0272C4.60942 18.225 4.6888 18.4656 4.88666 18.5651L7.47897 19.8683C7.67683 19.9667 7.91734 19.8873 8.01686 19.6906ZM15.1362 19.6527L17.1942 9.21947C17.2369 9.00266 17.0971 8.79295 16.8803 8.74912L14.0356 8.17449C13.8188 8.13066 13.6067 8.27165 13.5628 8.48846V8.48965L11.5049 18.9229C11.4622 19.1397 11.602 19.3494 11.8188 19.3932L14.6635 19.9679C14.8803 20.0117 15.0924 19.8707 15.1362 19.6539C15.1362 19.6539 15.1362 19.6539 15.1362 19.6527Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_18732_33912)">
        <path
          d="M22.3459 7.15527H3.65234V20.99H22.3459V7.15527Z"
          fill="#374151"
        />
        <mask
          id="mask1_18732_33912"
          maskUnits="userSpaceOnUse"
          x="3"
          y="7"
          width="20"
          height="14"
        >
          <path
            d="M22.3479 7.15576H3.6543V20.9905H22.3479V7.15576Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask1_18732_33912)">
          <path
            d="M22.3498 7.15625H3.65625V20.991H22.3498V7.15625Z"
            fill="#374151"
          />
          <mask
            id="mask2_18732_33912"
            maskUnits="userSpaceOnUse"
            x="3"
            y="7"
            width="20"
            height="14"
          >
            <path
              d="M22.3518 7.15674H3.6582V20.9915H22.3518V7.15674Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask2_18732_33912)">
            <path
              d="M22.3591 7.06152H3.60156V21.0574H22.3591V7.06152Z"
              fill="#1F2937"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
